export default __webpack_public_path__ + "static/img/collections-men-kaftans-bg.b3787b4.jpg";